export const SalesReport = [
  {
    id: '1',
    service: 'Computer Repair',
    provider: 'John Smith',
    sales: '20',
    amount: '$1060.00',
    img: 'assets/admin/img/services/service-03.jpg',
  },
  {
    id: '2',
    service: 'Car Repair Services',
    provider: 'John Smith',
    sales: '50',
    amount: '$1278.00',
    img: 'assets/admin/img/services/service-02.jpg',
  },
  {
    id: '3',
    service: 'Steam Car Wash',
    provider: 'Steam Car Wash',
    sales: '90',
    amount: '$12450.00',
    img: 'assets/admin/img/services/service-04.jpg',
  },
  {
    id: '4',
    service: 'House Cleaning ',
    provider: 'James',
    sales: '60',
    amount: '$14500.00',
    img: 'assets/admin/img/services/service-09.jpg',
  },
];
